
import { useState } from 'react';
import type { DebugInfo } from '../types/debugTypes';

export function useEnrichmentDebug() {
  const [showDebugInfo, setShowDebugInfo] = useState(false);
  const [debugInfo, setDebugInfo] = useState<DebugInfo | null>(null);

  const clearDebugInfo = () => {
    setDebugInfo(null);
  };

  const setErrorDebugInfo = (
    error: Error,
    errorLogs: string[],
    companyName: string,
    companyWebsite: string
  ) => {
    setDebugInfo({
      error: {
        message: error.message,
        stack: error.stack,
        errorCause: (error as any).errorCause,
        details: (error as any).details,
        debug: (error as any).debug
      },
      errorLogs,
      requestData: {
        company_name: companyName,
        company_website: companyWebsite
      },
      timestamp: new Date().toISOString()
    });
    setShowDebugInfo(true);
  };

  const setSuccessDebugInfo = (
    data: any,
    companyName: string,
    companyWebsite: string
  ) => {
    setDebugInfo({
      success: true,
      response: data,
      requestData: {
        company_name: companyName,
        company_website: companyWebsite
      },
      debug: data.debug,
      timestamp: new Date().toISOString()
    });
  };

  return {
    showDebugInfo,
    setShowDebugInfo,
    debugInfo,
    clearDebugInfo,
    setErrorDebugInfo,
    setSuccessDebugInfo
  };
}
